import { render, staticRenderFns } from "./public_home.vue?vue&type=template&id=49f6b478&scoped=true"
import script from "./public_home.vue?vue&type=script&lang=js"
export * from "./public_home.vue?vue&type=script&lang=js"
import style0 from "./public_home.vue?vue&type=style&index=0&id=49f6b478&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f6b478",
  null
  
)

export default component.exports